import * as ActionTypes from 'actions';

/* eslint no-console: ["error", { allow: ["error"] }] */

const initialState = {
  myTripsData: [],
  isLoading: false,
  response: {},
  search: '',
};

export default function(state = initialState, action = {}) {
  const { type, response, id, error, payload } = action;

  switch (type) {
  case ActionTypes.MY_TRIPS_REQUEST:
    return Object.assign({}, state, { myTripsData: [], isLoading: true });

  case ActionTypes.MY_TRIPS_SUCCESS: {
    const myTripsData = response.data.length ? response.data : {};

    return Object.assign({}, state, { myTripsData: myTripsData, response, isLoading: false });
  }

  case ActionTypes.MY_TRIPS_FAILURE:
    console.error('Error loading my trips', error);

    return Object.assign({}, state, { response, isLoading: false });

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/myTrips.js